import { useEffect, useState } from "react";
import { fetchProStats } from "@/lib/api";
import { Eye, Heart, MessageCircle, Rocket, Crown } from "lucide-react";

export default function ProStatsPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchProStats().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;
  const t = data.totals;
  const top = data.annonces.slice(0, 5);

  return (
    <div className="glass-card p-5 mb-5 border-amber-200 bg-gradient-to-br from-amber-50/60 to-white" data-testid="pro-stats-panel">
      <div className="font-bold text-sm inline-flex items-center gap-2 mb-3">
        <span className="inline-flex items-center gap-1 bg-gradient-to-r from-amber-400 to-yellow-500 text-amber-950 text-[10px] font-extrabold px-2 py-1 rounded-full">
          <Crown size={11} /> PRO
        </span>
        Statistiques de vos annonces
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Stat icon={Eye} label="Vues totales" value={t.views} testid="pro-stat-views" />
        <Stat icon={Heart} label="Favoris" value={t.favorites} testid="pro-stat-favorites" />
        <Stat icon={MessageCircle} label="Conversations" value={t.conversations} testid="pro-stat-conversations" />
        <Stat icon={Rocket} label="Auto-bump actifs" value={t.auto_bump_enabled} testid="pro-stat-autobump" />
      </div>
      {top.length > 0 && (
        <div className="mt-4">
          <div className="text-[10px] uppercase tracking-widest font-bold text-[var(--ink-soft)] mb-2">Top annonces par vues</div>
          <div className="space-y-1.5">
            {top.map((a) => (
              <div key={a.id} className="flex items-center justify-between text-sm gap-2" data-testid={`pro-stats-row-${a.id}`}>
                <span className="truncate font-semibold flex-1">{a.title}</span>
                <span className="inline-flex items-center gap-3 text-xs text-[var(--ink-soft)] flex-shrink-0">
                  <span className="inline-flex items-center gap-1"><Eye size={12} /> {a.views || 0}</span>
                  <span className="inline-flex items-center gap-1"><Heart size={12} /> {a.favorites}</span>
                  <span className="inline-flex items-center gap-1"><MessageCircle size={12} /> {a.conversations}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function Stat({ icon: Icon, label, value, testid }) {
  return (
    <div className="rounded-2xl border border-amber-200 bg-white p-3" data-testid={testid}>
      <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold text-amber-700">
        <Icon size={12} /> {label}
      </div>
      <div className="text-2xl font-extrabold mt-1">{(value || 0).toLocaleString("fr-FR")}</div>
    </div>
  );
}
